import { unstable_createMuiStrictModeTheme as createTheme } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
export const darkTheme = createTheme({
  palette: {
    type: 'dark',
    background: {
      default: '#0d1117',
    },
    primary: {
      main: '#3e8bff',
    },
    secondary: {
      main: '#10181f',
    },
    action: {
      hover: '#3e8bff',
    },
    customGrey: {
      light: '#c3ccd7',
      main: '#6e767f',
      dark: '#98a1ac',
      contrastText: '#fff',
    },
    customBlack: {
      dark: '#192029',
      main: '#0B1017',
      light: '#232C39',
      contrastText: '#fff',
    },
  },
  overrides: {
    MuiButton: {
      root: {
        textTransform: 'none',
        fontSize: 13,
        backgroundColor: '#0e1319',
      },
    },
    MuiDialogContent: {
      // root: {
      //   overflow: 'hidden !important',
      // },
    },
    MuiSwitch: {
      switchBase: {
        // Controls default (unchecked) color for the thumb
        color: '#323d4e !important',
      },
      colorSecondary: {
        '&$checked': {
          // Controls checked color for the thumb
          color: '#f2ff00',
        },
      },
      track: {
        // Controls default (unchecked) color for the track
        opacity: 0.2,
        backgroundColor: COLORS.PRIMARY + '!important',
        '$checked$checked + &': {
          // Controls checked color for the track
          opacity: 0.7,
          backgroundColor: '#505d6d !important',
        },
      },
    },
    MuiInputLabel: {
      root: {
        color: '#fff !important',
      },
    },
    MuiInputBase: {
      root: {
        backgroundColor: 'transparent !important',
      },
      input: {
        '&::placeholder': {
          color: '#fff !important',
          fontWeight: 500,
          fontSize: '12px !important',
          opacity: '0.8 !important',
        },
      },
    },
    MuiMenuItem: {
      root: {
        '&:hover': {
          backgroundColor: COLORS.PRIMARY + '!important',
        },
      },
    },
    MuiPaper: {
      root: {
        '& .MuiAutocomplete-option': {
          '&:hover': {
            backgroundColor: COLORS.PRIMARY,
          },
          '&[data-focus="true"]': {
            backgroundColor: COLORS.PRIMARY,
          },
        },
      },
    },
    MuiSnackbarContent: {
      root: {
        backgroundColor: '#333',
        color: COLORS.WHITE,
        boxShadow: 'none',
        border: 'none',
      },
    },
    MuiCssBaseline: {
      '@global': {
        '*': {
          '&::-webkit-scrollbar-track': {
            backgroundColor: COLORS.DARK_BACKGROUND,
          },
        },
      },
    },
  },
});
